module.exports = __webpack_public_path__ + "7ec259a15391cad2df4b65eebf4cb1bf.png";